import { useCallback } from 'react';
import { ReportMessageContent } from 'src/models';
import { useApiError, useAppData } from 'src/providers';
import { DateRange } from '@material-ui/pickers';
import { getReports } from '../MasterIbCommissionService';
import { trackAmplitudeData } from '../../../../services/amplitudeService';
import { MasterIbCommissionModel } from '../MasteIBCommissionModel';

const useGetReports = ({
  dateRange,
  setReportData,
  showReports,
  setIsLoading,
  setShowReports,
}: {
  dateRange: DateRange<Date>;
  showReports: boolean;
  setIsLoading: (data: boolean) => void;
  setShowReports: (data: boolean) => void;
  setReportData: (data?: MasterIbCommissionModel) => void;
}) => {
  const { addError } = useApiError();
  const { userData } = useAppData();

  return useCallback(async () => {
    const loginData = JSON.parse(userData);

    if (dateRange && dateRange[0] && dateRange[1]) {
      const messageContent: ReportMessageContent = {
        PartnerId: loginData.partnerID,
        Month: dateRange[0].getMonth() + 1,
        Year: dateRange[0].getFullYear(),
        Day: dateRange[0].getDate(),
        EndMonth: dateRange[1].getMonth() + 1,
        EndYear: dateRange[1].getFullYear(),
        EndDay: dateRange[1].getDate(),
        ConvertToCurrency: 'USD',
        RequestorAccountGuid: loginData.defaultAccount,
      };

      setIsLoading(true);

      try {
        trackAmplitudeData('partnerPortal_action_report', {
          type: 'Requested',
          report_name: 'Master IB Commission',
        });

        const response = await getReports(messageContent);

        setReportData(response.data);

        if (!showReports) {
          setShowReports(true);
        }
      } catch (error) {
        setReportData();
        addError(JSON.stringify(error.response));
      } finally {
        setIsLoading(false);
      }
    }
  }, [userData, dateRange, setIsLoading, setReportData, showReports, setShowReports, addError]);
};

export default useGetReports;
